(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-personalization-fields"] && !Shopify.designMode) return;
  try {
    (function initProductPersonalization() {
    if (window.__faiencaPersonalizationInit) return;
    window.__faiencaPersonalizationInit = true;

    const acceptedTypes = ['image/jpeg', 'image/png', 'image/webp'];
    const acceptedExtensions = ['.jpg', '.jpeg', '.png', '.webp'];

    const isAcceptedFile = (file) => {
      if (!file) return false;
      if (file.type && acceptedTypes.includes(file.type)) return true;
      const name = (file.name || '').toLowerCase();
      return acceptedExtensions.some((ext) => name.endsWith(ext));
    };

    const fieldErrorElement = (field) => {
      const describedBy = field.getAttribute('aria-describedby') || '';
      const errorId = describedBy.split(/\s+/).find((id) => id.endsWith('-error'));
      return errorId ? document.getElementById(errorId) : null;
    };

    const showError = (field, message) => {
      const errorEl = fieldErrorElement(field);
      field.setAttribute('aria-invalid', 'true');
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
    };

    const clearError = (field) => {
      const errorEl = fieldErrorElement(field);
      field.removeAttribute('aria-invalid');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    };

    const bindBlock = (block) => {
      if (!(block instanceof HTMLElement) || block.dataset.bound === 'true') return;
      block.dataset.bound = 'true';

      const form = block.closest('form');
      if (!form) return;

      const requiredMessage = block.dataset.errorRequired || '';
      const fileSizeMessage = block.dataset.errorFileSize || '';
      const fileTypeMessage = block.dataset.errorFileType || '';
      const maxFileSize = Number(block.dataset.maxFileSize || 10485760);
      const productId = block.dataset.productId;

      const requiredFields = Array.from(
        block.querySelectorAll('input[required], select[required], textarea[required]')
      );
      const fileInput = block.querySelector('input[type="file"]');
      const validatedFields = fileInput ? requiredFields.concat([fileInput]) : requiredFields;

      // ── Upload zone label interactif ──────────────────────────────────
      const uploadZone = block.querySelector('.pp__upload-zone');
      const fileNameEl = uploadZone && uploadZone.querySelector('.pp__upload-filename');
      const uploadCta = uploadZone && uploadZone.querySelector('.pp__upload-cta');
      const uploadTypes = uploadZone && uploadZone.querySelector('.pp__upload-types');

      if (uploadZone && fileInput) {
        // Rendre la zone cliquable (le label est déjà relié via for)
        uploadZone.setAttribute('tabindex', '0');
        uploadZone.setAttribute('role', 'button');
        uploadZone.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            fileInput.click();
          }
        });

        const updateZone = () => {
          const file = fileInput.files && fileInput.files[0];
          if (file) {
            uploadZone.classList.add('pp__upload-zone--has-file');
            if (fileNameEl) {
              fileNameEl.textContent = file.name;
              fileNameEl.hidden = false;
            }
            if (uploadCta) uploadCta.style.display = 'none';
            if (uploadTypes) uploadTypes.style.display = 'none';
          } else {
            uploadZone.classList.remove('pp__upload-zone--has-file');
            if (fileNameEl) fileNameEl.hidden = true;
            if (uploadCta) uploadCta.style.display = '';
            if (uploadTypes) uploadTypes.style.display = '';
          }
        };

        fileInput.addEventListener('change', updateZone);
        // Drag & drop sur la zone
        uploadZone.addEventListener('dragover', (e) => {
          e.preventDefault();
          uploadZone.classList.add('pp__upload-zone--drag');
        });
        uploadZone.addEventListener('dragleave', () => {
          uploadZone.classList.remove('pp__upload-zone--drag');
        });
        uploadZone.addEventListener('drop', (e) => {
          e.preventDefault();
          uploadZone.classList.remove('pp__upload-zone--drag');
          if (e.dataTransfer && e.dataTransfer.files.length) {
            const dt = new DataTransfer();
            dt.items.add(e.dataTransfer.files[0]);
            fileInput.files = dt.files;
            fileInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      // ── Validation ───────────────────────────────────────────────────
      const validateFile = () => {
        if (!fileInput) return true;
        const file = fileInput.files && fileInput.files[0];
        if (!file) {
          fileInput.setCustomValidity('');
          clearError(fileInput);
          return true;
        }
        if (!isAcceptedFile(file)) {
          fileInput.setCustomValidity(fileTypeMessage);
          showError(fileInput, fileTypeMessage);
          return false;
        }
        if (file.size > maxFileSize) {
          fileInput.setCustomValidity(fileSizeMessage);
          showError(fileInput, fileSizeMessage);
          return false;
        }
        fileInput.setCustomValidity('');
        clearError(fileInput);
        return true;
      };

      const isPersonalizationValid = () => {
        const requiredOk = requiredFields.every((field) =>
          field.type === 'checkbox' ? field.checked : String(field.value || '').trim() !== ''
        );
        return requiredOk && validateFile();
      };

      const getAddToCartButton = () => form.querySelector('[ref="addToCartButton"]');

      const getStickyButton = () => {
        if (!productId) return null;
        return document.querySelector(`sticky-add-to-cart[data-product-id="${productId}"] [ref="addToCartButton"]`);
      };

      let syncingButtons = false;
      const syncAddToCartState = () => {
        if (syncingButtons) return;
        syncingButtons = true;
        const button = getAddToCartButton();
        if (button) {
          const inventoryDisabled = button.dataset.inventoryDisabled === 'true';
          const shouldDisable = inventoryDisabled || !isPersonalizationValid();
          if (button.disabled !== shouldDisable) button.disabled = shouldDisable;
        }
        const stickyButton = getStickyButton();
        if (stickyButton) {
          const stickyUnavailable = stickyButton.closest('sticky-add-to-cart')?.dataset.variantAvailable === 'false';
          const stickyShouldDisable = stickyUnavailable || !isPersonalizationValid();
          if (stickyButton.disabled !== stickyShouldDisable) stickyButton.disabled = stickyShouldDisable;
        }
        syncingButtons = false;
      };

      const validateAndFocus = () => {
        let firstInvalid = null;
        requiredFields.forEach((field) => {
          const valid = field.type === 'checkbox' ? field.checked : String(field.value || '').trim() !== '';
          if (!valid) {
            showError(field, requiredMessage);
            if (!firstInvalid) firstInvalid = field;
          } else {
            clearError(field);
          }
        });
        if (!validateFile() && fileInput && !firstInvalid) firstInvalid = fileInput;
        if (firstInvalid) {
          firstInvalid.focus({ preventScroll: false });
          block.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }
        return true;
      };

      validatedFields.forEach((field) => {
        const handleUpdate = () => {
          if (field === fileInput) {
            validateFile();
          } else if (field.type === 'checkbox' ? field.checked : String(field.value || '').trim() !== '') {
            clearError(field);
          }
          syncAddToCartState();
        };
        field.addEventListener('input', handleUpdate);
        field.addEventListener('change', handleUpdate);
        field.addEventListener('invalid', (event) => {
          event.preventDefault();
          field === fileInput ? validateFile() : showError(field, requiredMessage);
        });
      });

      form.addEventListener(
        'submit',
        (event) => {
          if (!validateAndFocus()) {
            event.preventDefault();
            event.stopImmediatePropagation();
            return;
          }
          if (fileInput && (!fileInput.files || fileInput.files.length === 0)) {
            fileInput.disabled = true;
            setTimeout(() => {
              fileInput.disabled = false;
            }, 0);
          }
        },
        true
      );

      const section = form.closest('.shopify-section');
      section?.addEventListener('variant:update', (event) => {
        const button = getAddToCartButton();
        if (!button) return;
        const resource = event.detail?.resource;
        button.dataset.inventoryDisabled = resource?.available ? 'false' : 'true';
        requestAnimationFrame(syncAddToCartState);
      });

      const button = getAddToCartButton();
      if (button) {
        if (button.dataset.inventoryDisabled === undefined) {
          button.dataset.inventoryDisabled = button.disabled ? 'true' : 'false';
        }
        const observer = new MutationObserver(() => {
          syncAddToCartState();
        });
        observer.observe(button, { attributes: true, attributeFilter: ['disabled'] });
      }

      const stickyRoot = productId
        ? document.querySelector(`sticky-add-to-cart[data-product-id="${productId}"]`)
        : null;
      stickyRoot?.addEventListener(
        'click',
        (event) => {
          if (!event.target.closest('[ref="addToCartButton"]')) return;
          if (isPersonalizationValid()) return;
          event.preventDefault();
          event.stopPropagation();
          validateAndFocus();
        },
        true
      );

      syncAddToCartState();
    };

    const bindAll = () => {
      document.querySelectorAll('[data-product-personalization]').forEach(bindBlock);
    };

    bindAll();

    const domObserver = new MutationObserver(bindAll);
    if (document.body) {
      domObserver.observe(document.body, { childList: true, subtree: true });
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        bindAll();
        if (document.body) domObserver.observe(document.body, { childList: true, subtree: true });
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
